module.exports = __webpack_public_path__ + "static/img/A168.11a1c647.jpg";